/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { type Insight as BaseInsight, registerStandardChartInsight } from '../insightManager';
import { toArray } from '../../util/data';
import { findSeriesDataItemInfo } from '../../helper/standardChart';
import { handleAnimation } from '../helper';

type InsightData = {
  /** x 轴指标对应数据集字段 */
  x: string;
  /** y 轴指标对应数据集字段 */
  y: string;
  /** 要标记的 y 轴指标数据值 */
  yValue: string;
  /** 线的文本描述 */
  summary: string;
  /** 线的配置 @see https://echarts.apache.org/zh/option.html#series-bar.markLine.data */
  line?: unknown;
};

const type = 'Line';
const INSIGHT_FLAG = `insight_${type}`;

interface Insight extends BaseInsight<InsightData[]> {
  readonly type: typeof type;
}

registerStandardChartInsight<Insight>({
  type,
  filter: option => {
    return (
      toArray(option.xAxis).length > 0 &&
      toArray(option.yAxis).length > 0 &&
      !toArray(option.series).some(item => !['line', 'bar', 'scatter'].includes(item.type))
    );
  },
  clear: {
    onOptionUpdate(option) {
      option.series = toArray(option.series).map(series => {
        series.markLine = series.markLine || {};
        series.markLine.data = (series.markLine.data || []).filter(
          item => item.__insightFlag !== INSIGHT_FLAG
        );

        return series;
      });
    }
  },
  render: {
    onOptionUpdate(context, option) {
      const insight = context.insightOption;
      const { animationDuration = 0 } = insight;

      function renderLine(data: InsightData) {
        const { x, y, yValue, summary, line: lineOpt = {} } = data;
        const startDataItemMetaInfo = findSeriesDataItemInfo(option, {
          xField: x,
          yField: y,
          yValue
        });
        if (!startDataItemMetaInfo) {
          return;
        }
        const { seriesIndex } = startDataItemMetaInfo;
        const series = context.util.data.toArray(option.series)[seriesIndex];

        series.markLine = series.markLine || {};
        series.markLine.data = series.markLine.data || [];

        const line = {
          ...context.util.data.deepMerge(lineOpt, {
            // ! bugs @see https://github.com/apache/echarts/issues/18433
            symbol: 'none',
            dvSymbolNone: true,
            label: {
              position: 'insideStartTop'
            }
          }),
          // ! name 在该模式下不生效
          name: summary,
          dvLabelText: summary,
          yAxis: yValue,
          __insightFlag: INSIGHT_FLAG
        };

        series.markLine.data.push(line);
        handleAnimation(series.markLine, animationDuration);
      }

      insight.data.forEach(item => renderLine(item));
    }
  }
});
